import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, AlertTriangle, MapPin, Wallet, Phone, Flag } from 'lucide-react';
import { SCShell, SCHeading, ghostBtn } from './sc/SCShared';

const tips = [
  { icon: Wallet, t: 'Protect your finances', items: ['Never send money to someone you met online', 'Never share financial or banking information', 'Be wary of anyone asking to move to outside payment apps'] },
  { icon: MapPin, t: 'Meet safely', items: ["Don't share your home address early on", 'Meet new people in public places', 'Tell a trusted person where you\u2019re going', 'Use your own transportation when possible'] },
  { icon: Flag, t: 'Report concerns', items: ['Report harassment, threats or hate/abusive behavior', 'Report impersonation, fake profiles and scams', 'Report inappropriate sexual behavior', 'Report anyone soliciting money'] },
];

const SCSafety = () => (
  <SCShell>
    <SCHeading eyebrow="Sacred Connections" title="Safety Center" sub="Your wellbeing comes first. Please keep these guidelines in mind as you connect." />
    <div className="rounded-2xl p-6 border border-[#f5d786]/30 bg-[#f5d786]/[0.06] mb-8 flex gap-4" data-testid="sc-safety-emergency">
      <AlertTriangle className="h-6 w-6 text-[#f5d786] shrink-0" />
      <p className="font-jost text-sm text-[#e9d8ff]/85">If you are ever in immediate danger, contact your local emergency services right away. Trust your instincts — if something feels wrong, step away.</p>
    </div>
    <div className="grid md:grid-cols-3 gap-5">
      {tips.map((c, i) => (
        <div key={i} className="rounded-2xl p-6 border border-[#8b5cf6]/20 bg-white/[0.03] backdrop-blur-md">
          <div className="flex items-center gap-3 mb-4"><c.icon className="h-5 w-5 text-[#d946ef]" /><h3 className="font-cinzel text-base text-[#f5d786]">{c.t}</h3></div>
          <ul className="space-y-2">
            {c.items.map((it) => <li key={it} className="font-jost text-sm text-[#e9d8ff]/70 flex gap-2"><ShieldCheck className="h-4 w-4 text-[#8b5cf6] shrink-0 mt-0.5" />{it}</li>)}
          </ul>
        </div>
      ))}
    </div>
    <div className="mt-10 text-center">
      <Link to="/sacred-connections" className={ghostBtn} data-testid="sc-safety-back">Back to Sacred Connections</Link>
    </div>
  </SCShell>
);

export default SCSafety;
